// Helpers d'accès à l'API : gestion centralisée des tokens admin et client.

export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || 'http://localhost:3001';

const ADMIN_TOKEN_KEY = 'fief_admin_token';
const CUSTOMER_TOKEN_KEY = 'fief_customer_token';

// --- Admin ---

export const getAdminToken = () => localStorage.getItem(ADMIN_TOKEN_KEY);
export const setAdminToken = (token) => localStorage.setItem(ADMIN_TOKEN_KEY, token);
export const clearAdminToken = () => localStorage.removeItem(ADMIN_TOKEN_KEY);

// fetch authentifié admin. onUnauthorized est appelé si le token est expiré/invalide.
export const adminFetch = async (path, options = {}, onUnauthorized) => {
  const response = await fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: `Bearer ${getAdminToken()}`
    }
  });

  if (response.status === 401 && onUnauthorized) {
    clearAdminToken();
    onUnauthorized();
  }

  return response;
};

// --- Client (fidélité) ---

export const getCustomerToken = () => localStorage.getItem(CUSTOMER_TOKEN_KEY);
export const setCustomerToken = (token) => localStorage.setItem(CUSTOMER_TOKEN_KEY, token);
export const clearCustomerToken = () => localStorage.removeItem(CUSTOMER_TOKEN_KEY);

export const customerFetch = async (path, options = {}) => {
  const token = getCustomerToken();
  return fetch(`${API_URL}${path}`, {
    ...options,
    headers: {
      ...(options.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    }
  });
};
